import { ReactElement } from 'react';

import { useUIConfiguration } from '@cashier/cashier-shared';
import { cn } from '@cashier/cashier-ui';

import { useErrorList } from '../hooks';

import styles from './styles.module.scss';

export const ErrorList = (): ReactElement | null => {
  const errorsType = useUIConfiguration('errors', 'type');
  const errors = useErrorList();

  if (!errors.length) {
    return null;
  }

  const containerStyles = cn({
    [styles.base]: true,
    [styles.container]: errorsType === 'container',
    [styles.default]: errorsType === 'default',
  });

  return (
    <ul className={containerStyles} data-test="input-error">
      {errors.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </ul>
  );
};
